<template>
  <div class="intro-tone-content" id="identidade-verbal-tom-introducao" data-search-anchor>
    <div class="intro-tone-title-content">
      <h1 class="intro-tone-title">{{ introTitle }}</h1>
      <p class="intro-tone-paragraph">{{ introParagraph }}</p>
    </div>

    <div
      class="intro-tone-card-item"
      :style="{ backgroundImage: `url(${introImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import TonePageMixin from '@/mixins/tone-page-mixin'
import { TonePageStore } from '@/store/verbal-identity-page/tone-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ToneIntroSection extends Mixins(TonePageMixin) {
  tonePageStore: PageStoreContract = getModule(TonePageStore, this.$store)

  get introTitle(): string {
    return this.getElementTitle(1, 0)
  }

  get introParagraph(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

   async getTonePage(): Promise<void> {
    await this.tonePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.tonePageStore.isLoading) {
      await this.getTonePage()
    }
  }
}
</script>

<style lang="scss">
.intro-tone-content {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  max-width: 1032px;  
}

.intro-tone-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  padding-right: 16px;
}

.intro-tone-paragraph {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-top: 47px;
  white-space: pre; 
} 

.intro-tone-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
}

</style>

